export const DocumentLinksConfig = Object.freeze({
  collectionAndProcessingPersonalData: {
    ru: `/documents/collection_and_processing_personal_data_kgcs_ru.pdf`,
    kg: `/documents/collection_and_processing_personal_data_kgcs_kg.pdf`,
  },
  consultingAgreement: {
    ru: `/documents/consulting_agreement_ru.pdf`,
    kg: `/documents/consulting_agreement_kg.pdf`,
  },
  scoringAgreement: {
    ru: `/documents/scoring_agreement_ru.pdf`,
    kg: `/documents/scoring_agreement_kg.pdf`,
  },
  collectionAndProcessingPersonalDataZamat: {
    ru: `/documents/collection_and_processing_personal_data_zamat_ru.pdf`,
    kg: `/documents/collection_and_processing_personal_data_zamat_kg.pdf`,
  },
  additionalAgreementOld: {
    ru: `/documents/additional_agreement_old_ru.pdf`,
    kg: `/documents/additional_agreement_old_kg.pdf`,
  },
  additionalAgreement: {
    ru: `/documents/additional_agreement_ru.pdf`,
    kg: `/documents/additional_agreement_kg.pdf`,
  },
  rolloverAgreement: {
    ru: `/documents/rollover_agreement_ru.pdf`,
    kg: `/documents/rollover_agreement_kg.pdf`,
  },
  rolloverInterestFee: {
    ru: `/documents/rollover_interest_fee_ru.pdf`,
    kg: `/documents/rollover_interest_fee_kg.pdf`,
  },
  additionalScoringKgcs: {
    ru: `/documents/additional_scoring_kgcs_ru.pdf`,
    kg: `/documents/additional_scoring_kgcs_kg.pdf`,
  },
  consentOfCreditInfo: {
    ru: `/documents/consent_of_credit_info_ru.pdf`,
    kg: `/documents/consent_of_credit_info_kg.pdf`,
  },
  provideInfoToCreditBureau: {
    ru: `/documents/provide_info_to_credit_bureau_ru.pdf`,
    kg: `/documents/provide_info_to_credit_bureau_kg.pdf`,
  },
  loanAgreement: {
    ru: `/documents/loan_agreement_ru.pdf`,
    kg: `/documents/loan_agreement_kg.pdf`,
  },
  insuranceAgreement: {
    ru: `/documents/insurance_agreement_ru.pdf`,
    kg: `/documents/insurance_agreement_kg.pdf`,
  },
  insuranceAgreementDordoi: {
    ru: `/documents/insurance_agreement_dordoi_ru.pdf`,
    kg: `/documents/insurance_agreement_dordoi_kg.pdf`,
  },
  insurancePolicy: {
    ru: `/documents/insurance_policy_ru.pdf`,
    kg: `/documents/insurance_policy_kg.pdf`,
  },
  insurancePolicyDordoi: {
    ru: `/documents/insurance_policy_dordoi_ru.pdf`,
    kg: `/documents/insurance_policy_dordoi_kg.pdf`,
  },
});
